let notifierElement = null;

const defaultNotification = {
    dismissible: true
};

export default (() => {

    function addNotification(params) {

        notifierElement.addNotification({
            ...params,
            defaultNotification
        });

        // Accessibility: allow screen reader to detect and read alert messages
        document.getElementsByClassName('notifications-wrapper')[0].setAttribute('role', 'alert');
    }

    function setNotifierElement(elem) {

        notifierElement = elem;
    }

    return {
        setNotifierElement,
        addNotification
    };
})();
